import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { documentApiResponseSuccess, documentApiResponseError } from './actions';
import { DocumentsActionTypes } from './constants';
import { toggleLoading } from '../actions';
import {
    createDocument as createDocumentApi,
    updateDocument as updateDocumentApi,
    getDocument as getDocumentApi,
    getDocuments as getDocumentsApi,
    getDocumentsByTransaction as getDocumentsByTransactionApi,
    getDocumentsByTransactions as getDocumentsByTransactionsApi,
    getDocumentsByListing as getDocumentsByListingApi,
    getDocumentsByOwner as getDocumentsByOwnerApi,
    deleteDocument as deleteDocumentApi,
} from '../../helpers';

/**
 * Get Documents
 */
function* getDocuments() {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentsApi);
        yield put(documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENTS, response.data));
    } catch (error) {
        console.log(error);
        yield put(documentApiResponseError(DocumentsActionTypes.GET_DOCUMENTS, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get Document by ID
 */
function* getDocument({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentApi, { id });
        yield put(documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENT, response.data));
    } catch (error) {
        console.log(error);
        yield put(documentApiResponseError(DocumentsActionTypes.GET_DOCUMENT, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get Documents by Transaction
 */
function* getDocumentsByTransaction({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentsByTransactionApi, { id });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Get Documents by Transactions
 */
function* getDocumentsByTransactions({ payload: { ids } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentsByTransactionsApi, { ids });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Get Documents by Listing
 */
function* getDocumentsByListing({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentsByListingApi, { id });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Get Documents by Owner
 */
function* getDocumentsByOwner({ payload: { owner } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getDocumentsByOwnerApi, { owner });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Create Document
 */
function* createDocument({ payload: { data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(createDocumentApi, { data });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.CREATE_DOCUMENT, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.CREATE_DOCUMENT, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Update Document
 */
function* updateDocument({ payload: { id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(updateDocumentApi, { id, data });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.UPDATE_DOCUMENT, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.UPDATE_DOCUMENT, error)
        );
    }
    yield put(toggleLoading(false));
}

/**
 * Delete Document
 */
function* deleteDocument({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(deleteDocumentApi, { id });
        yield put(
            documentApiResponseSuccess(DocumentsActionTypes.DELETE_DOCUMENT, response.data)
        );
    } catch (error) {
        console.log(error);
        yield put(
            documentApiResponseError(DocumentsActionTypes.DELETE_DOCUMENT, error)
        );
    }
    yield put(toggleLoading(false));
}

/* =====================
   Watchers
   ===================== */

export function* watchGetDocuments() {
    yield takeEvery(DocumentsActionTypes.GET_DOCUMENTS, getDocuments);
}

export function* watchGetDocument() {
    yield takeEvery(DocumentsActionTypes.GET_DOCUMENT, getDocument);
}

export function* watchGetDocumentsByTransaction() {
    yield takeEvery(
        DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION,
        getDocumentsByTransaction
    );
}

export function* watchGetDocumentsByTransactions() {
    yield takeEvery(
        DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS,
        getDocumentsByTransactions
    );
}

export function* watchGetDocumentsByListing() {
    yield takeEvery(
        DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING,
        getDocumentsByListing
    );
}

export function* watchGetDocumentsByOwner() {
    yield takeEvery(
        DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER,
        getDocumentsByOwner
    );
}

export function* watchCreateDocument() {
    yield takeEvery(DocumentsActionTypes.CREATE_DOCUMENT, createDocument);
}

export function* watchUpdateDocument() {
    yield takeEvery(DocumentsActionTypes.UPDATE_DOCUMENT, updateDocument);
}

export function* watchDeleteDocument() {
    yield takeEvery(DocumentsActionTypes.DELETE_DOCUMENT, deleteDocument);
}

/**
 * Root Documents Saga
 */
function* documentsSaga() {
    yield all([
        fork(watchGetDocuments),
        fork(watchGetDocument),
        fork(watchGetDocumentsByTransaction),
        fork(watchGetDocumentsByTransactions),
        fork(watchGetDocumentsByListing),
        fork(watchGetDocumentsByOwner),
        fork(watchCreateDocument),
        fork(watchUpdateDocument),
        fork(watchDeleteDocument),
    ]);
}

export default documentsSaga;
